'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var nanoid = require('nanoid');
var useMergedRefs = require('./useMergedRefs-b6d2f8fc.js');
var lodash = require('lodash');
var editNote = require('./edit-note-c47d292e.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25;
var activeLabel = styled.css(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0 3px;\n  top: -7px;\n  letter-spacing: 0.03em;\n  left: 8px !important;\n  opacity: 1 !important;\n"])));
var Adornment = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  flex-shrink: 0;\n  font-family: inherit;\n  font-size: 0.875rem;\n  line-height: initial;\n  padding: 13px 10px;\n\n  ", "\n  ", "\n  border: 1px solid;\n  ", "\n  border-radius: 3px;\n  ", "\n  box-sizing: border-box;\n  appearance: none;\n  transition: border-color 350ms;\n  height: 2.75rem;\n\n  ", "\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-400'), props.theme.getColor('gray-500'));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-500'), props.theme.getColor('gray-400'));
}, function (props) {
  return props.isPrefix ? styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n          padding-right: 0;\n          margin-right: -3px;\n          border-right: 0;\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        "]))) : styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n          padding-left: 0;\n          margin-left: -3px;\n          border-left: 0;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        "])));
}, function (props) {
  return props.warning && styled.css(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n      border-color: ", " !important;\n    "])), props.theme.getColor('orange-500'));
}, function (props) {
  return props.error && styled.css(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n      border-color: ", " !important;\n    "])), props.theme.getColor('red-500'));
});
var TextInputWrapper = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  align-content: center;\n\n  &:focus-within {\n    ", " {\n      outline: none;\n      ", "\n    }\n  }\n"])), Adornment, function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-500'), props.theme.getColor('gray-600'), 1);
});
var InputIconContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 0;\n  pointer-events: none;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  padding-right: 4px;\n  padding-left: 30px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  > svg {\n    width: 12px;\n  }\n"])), function (props) {
  return props.theme.getColor('gray-400');
}, function (props) {
  return props.warning && props.theme.themeProp('color', '#C3AF43', '#C3AF43');
}, function (props) {
  return props.error && props.theme.themeProp('color', '#CB968F', '#CB968F');
});
var TextInputField = styled__default['default'].input.attrs(defaultTheme.applyDefaultTheme)(_templateObject9 || (_templateObject9 = defaultTheme._taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  font-size: 0.875rem;\n  line-height: 1;\n  padding: 13px 10px;\n  border-radius: 3px;\n  box-sizing: border-box;\n  appearance: none;\n  transition: border-color 350ms;\n  height: 2.75rem !important; // important is needed to override the default Foundation styling used in the Mediebank;\n  margin-bottom: 0; // needed to override the default Foundation styling used in the Mediebank;\n  ", "\n  ", "\n  border: 1px solid;\n  ", ";\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  &::placeholder {\n    ", "\n\n    ", "\n  }\n\n\n  &&:hover:not(:focus) {\n    ", ";\n    transition: background 350ms;\n    & + ", " {\n      opacity: 1;\n      transition: opacity 350ms;\n    }\n  }\n\n  :focus {\n    outline: none;\n    border-color: ", " !important\n    ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-100'), props.theme.getColor('gray-900'));
}, function (props) {
  return props.theme.themeProp('background', props.theme.getColor('gray-900'), props.theme.getColor('white'));
}, function (props) {
  return props.noBorder || props.readOnly ? 'border-color: transparent !important' : props.theme.themeProp('border-color', props.theme.getColor('gray-500'), props.theme.getColor('gray-400'));
}, function (props) {
  return props.readOnly && styled.css(_templateObject10 || (_templateObject10 = defaultTheme._taggedTemplateLiteral(["\n      user-select: text;\n      cursor: default;\n    "])));
}, function (props) {
  return props.warning && styled.css(_templateObject11 || (_templateObject11 = defaultTheme._taggedTemplateLiteral(["\n      border-color: ", " !important;\n    "])), props.theme.getColor('orange-500'));
}, function (props) {
  return props.error && styled.css(_templateObject12 || (_templateObject12 = defaultTheme._taggedTemplateLiteral(["\n      border-color: ", " !important;\n    "])), props.theme.getColor('red-500'));
}, function (props) {
  return props.hasIcon && styled.css(_templateObject13 || (_templateObject13 = defaultTheme._taggedTemplateLiteral(["\n      padding-left: 35px;\n    "])));
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'), 1);
}, function (props) {
  return props.theme.themeProp('opacity', 0.6, 0.5, 1);
}, function (props) {
  return props.noBorder ? props.theme.themeProp('background', props.theme.getColor('gray-700'), props.theme.getColor('gray-200')) : 'background: transparent';
}, InputIconContainer, function (props) {
  return props.theme.getColor('gray-600');
}, function (props) {
  return props.readOnly && styled.css(_templateObject14 || (_templateObject14 = defaultTheme._taggedTemplateLiteral(["\n        outline: none;\n      "])));
});
var TextInputLabel = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject15 || (_templateObject15 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  top: 15px;\n  left: 11px;\n  line-height: 1.2;\n  font-size: 0.875rem;\n  transition: all 150ms;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'));
}, function (props) {
  return props.theme.themeProp('opacity', 0.6, 0.5);
}, function (props) {
  return props.theme.themeProp('background', "linear-gradient(0deg, ".concat(props.theme.getColor('gray-900'), " calc(50% + 1px), transparent 50%)"), "linear-gradient(0deg, ".concat(props.theme.getColor('white'), " calc(50% + 1px), transparent 50%)"));
}, function (props) {
  return (props.hasPlaceholder || props.hasAdornments) && styled.css(_templateObject16 || (_templateObject16 = defaultTheme._taggedTemplateLiteral(["\n      ", ";\n    "])), activeLabel);
}, function (props) {
  return props.hasIcon && styled.css(_templateObject17 || (_templateObject17 = defaultTheme._taggedTemplateLiteral(["\n      left: 35px;\n    "])));
});
var TextInputFieldIcon = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject18 || (_templateObject18 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 2.625rem;\n  display: flex;\n  padding: 0 10px;\n\n  svg {\n    width: 15px;\n    opacity: 0.6;\n    transition: opacity 250ms;\n  }\n"])));
var TextInput$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject19 || (_templateObject19 = defaultTheme._taggedTemplateLiteral(["\n  position: relative;\n\n  ", "\n\n  &:focus-within {\n    ", " {\n      ", ";\n    }\n\n    ", " {\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n\n  ", ":not(:placeholder-shown) + ", " {\n    ", ";\n    ", "\n\n    ", "\n    ", " \n  } \n \n}\n"])), function (props) {
  return props.disabled && styled.css(_templateObject20 || (_templateObject20 = defaultTheme._taggedTemplateLiteral(["\n      user-select: none;\n      opacity: 0.5;\n      cursor: not-allowed;\n      > * {\n        pointer-events: none;\n      }\n    "])));
}, TextInputLabel, activeLabel, TextInputFieldIcon, TextInputField, TextInputLabel, activeLabel, function (props) {
  return props.error && props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500'));
}, function (props) {
  return props.error && styled.css(_templateObject21 || (_templateObject21 = defaultTheme._taggedTemplateLiteral(["\n        color: ", ";\n      "])), props.theme.getColor('red-500'));
}, function (props) {
  return props.warning && styled.css(_templateObject22 || (_templateObject22 = defaultTheme._taggedTemplateLiteral(["\n        color: ", ";\n      "])), props.theme.getColor('orange-500'));
});
var Description = styled__default['default'].p.attrs(defaultTheme.applyDefaultTheme)(_templateObject23 || (_templateObject23 = defaultTheme._taggedTemplateLiteral(["\n  margin: 8px 0 0 0;\n  padding: 0 0.6875rem;\n  font-size: 0.75rem;\n  line-height: 1.333;\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-400'), props.theme.getColor('gray-500'));
}, function (props) {
  return props.error && styled.css(_templateObject24 || (_templateObject24 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500')));
}, function (props) {
  return props.warning && styled.css(_templateObject25 || (_templateObject25 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('orange-500')));
});

var TextInput = React__default['default'].forwardRef(function TextInput(_ref, forwardedRef) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      type = _ref.type,
      required = _ref.required,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      autoComplete = _ref.autoComplete,
      description = _ref.description,
      error = _ref.error,
      warning = _ref.warning,
      icon = _ref.icon,
      adornments = _ref.adornments,
      className = _ref.className,
      style = _ref.style,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      noBorder = _ref.noBorder,
      rest = defaultTheme._objectWithoutProperties(_ref, ["value", "defaultValue", "name", "label", "placeholder", "type", "required", "disabled", "readOnly", "autoComplete", "description", "error", "warning", "icon", "adornments", "className", "style", "onChange", "onBlur", "noBorder"]);

  var textInputDomNode = React.useRef(null);
  var textInputRef = useMergedRefs.useMergedRefs(forwardedRef, textInputDomNode);

  var _useState = React.useState(nanoid.nanoid()),
      _useState2 = defaultTheme._slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  var hasError = React.useMemo(function () {
    if (lodash.isBoolean(error)) {
      return error;
    }

    return !lodash.isEmpty(error);
  }, [error]);
  var hasWarning = React.useMemo(function () {
    if (lodash.isBoolean(warning)) {
      return warning;
    }

    return !lodash.isEmpty(warning);
  }, [warning]);
  var descriptionText = React.useMemo(function () {
    if (!lodash.isEmpty(error)) {
      return error;
    }

    if (!lodash.isEmpty(warning)) {
      return warning;
    }

    if (!lodash.isEmpty(description)) {
      return description;
    }

    return null;
  }, [description, error, warning]);
  return React__default['default'].createElement(TextInput$1, {
    error: hasError,
    disabled: disabled,
    warning: hasWarning,
    className: className,
    style: style
  }, typeof icon !== 'undefined' && React__default['default'].createElement(TextInputFieldIcon, null, icon), React__default['default'].createElement(TextInputWrapper, null, typeof (adornments === null || adornments === void 0 ? void 0 : adornments.prefix) === 'string' && adornments.prefix.length > 0 && React__default['default'].createElement(Adornment, {
    htmlFor: "text-input-".concat(uniqueId),
    error: hasError,
    warning: hasWarning,
    isPrefix: true,
    onClick: function onClick() {
      return textInputDomNode.current.focus();
    }
  }, adornments.prefix), React__default['default'].createElement(TextInputField, defaultTheme._extends({
    ref: textInputRef,
    value: value,
    defaultValue: defaultValue,
    name: name,
    placeholder: placeholder || ' ',
    type: type,
    required: required,
    autoComplete: autoComplete,
    hasIcon: Boolean(icon),
    error: hasError,
    warning: hasWarning,
    id: "text-input-".concat(uniqueId),
    onChange: onChange,
    onBlur: onBlur,
    readOnly: readOnly,
    noBorder: noBorder
  }, rest)), !readOnly && noBorder && React__default['default'].createElement(InputIconContainer, {
    error: error,
    warning: warning
  }, React__default['default'].createElement(editNote.SvgEditNote, null)), label && React__default['default'].createElement(TextInputLabel, {
    htmlFor: "text-input-".concat(uniqueId),
    hasPlaceholder: Boolean(placeholder),
    hasAdornments: Boolean(typeof (adornments === null || adornments === void 0 ? void 0 : adornments.prefix) === 'string' && adornments.prefix.length > 0 || typeof (adornments === null || adornments === void 0 ? void 0 : adornments.suffix) === 'string' && adornments.suffix.length > 0),
    hasIcon: Boolean(icon),
    error: hasError
  }, label, required && ' *'), typeof (adornments === null || adornments === void 0 ? void 0 : adornments.suffix) === 'string' && adornments.suffix.length > 0 && React__default['default'].createElement(Adornment, {
    error: hasError,
    warning: hasWarning,
    isPrefix: false,
    onClick: function onClick() {
      return textInputDomNode.current.focus();
    }
  }, adornments.suffix)), typeof descriptionText === 'string' && descriptionText.length > 0 && React__default['default'].createElement(Description, {
    error: hasError,
    warning: hasWarning
  }, descriptionText));
});
TextInput.defaultProps = {
  type: 'text',
  noBorder: false
};
TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  value: defaultTheme.PropTypes.string,
  defaultValue: defaultTheme.PropTypes.string,
  name: defaultTheme.PropTypes.string,
  label: defaultTheme.PropTypes.string,
  placeholder: defaultTheme.PropTypes.string,
  type: defaultTheme.PropTypes.string,
  required: defaultTheme.PropTypes.bool,
  disabled: defaultTheme.PropTypes.bool,
  readOnly: defaultTheme.PropTypes.bool,
  autoComplete: defaultTheme.PropTypes.string,
  description: defaultTheme.PropTypes.string,
  error: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  warning: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  icon: defaultTheme.PropTypes.element,
  adornments: defaultTheme.PropTypes.shape({
    prefix: defaultTheme.PropTypes.string,
    suffix: defaultTheme.PropTypes.string
  }),
  className: defaultTheme.PropTypes.string,
  style: defaultTheme.PropTypes.object,
  onChange: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func,
  noBorder: defaultTheme.PropTypes.bool
} : {};

exports.TextInput = TextInput;
